import { render } from "./App.vue?vue&type=template&id=373f6290&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=373f6290&lang=scss"

import exportComponent from "/codebuild/output/src897194054/src/erp-bma/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__